import Vue from "vue";
import App from "./App.vue";
import initializeRouter from "./router";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

async function main() {
  const router = await initializeRouter();
  router.options.scrollBehavior = function(to, from, savedPosition) {
    return new Promise((resolve) => {
      resolve({ offset: { x: 0, y: 0 }, selector: "#main-view" });
    });
  };
  new Vue({
    router,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
}
main();
